/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationEmailDomainsUpdateRequest
 */
export interface OrganizationEmailDomainsUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationEmailDomainsUpdateRequest
     */
    emailDomains: Array<string>;
}

/**
 * Check if a given object implements the OrganizationEmailDomainsUpdateRequest interface.
 */
export function instanceOfOrganizationEmailDomainsUpdateRequest(value: object): value is OrganizationEmailDomainsUpdateRequest {
    if (!('emailDomains' in value) || value['emailDomains'] === undefined) return false;
    return true;
}

export function OrganizationEmailDomainsUpdateRequestFromJSON(json: any): OrganizationEmailDomainsUpdateRequest {
    return OrganizationEmailDomainsUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationEmailDomainsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationEmailDomainsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'emailDomains': json['emailDomains'],
    };
}

export function OrganizationEmailDomainsUpdateRequestToJSON(value?: OrganizationEmailDomainsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'emailDomains': value['emailDomains'],
    };
}

